import React from "react";

import { BlockStandard } from "components/admin/BlockStandard";
import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { ButtonLink } from "components/MUIExtensions/ButtonLink";

export const NoMonitoringCredentials = () => {
  return (
    <SolutionsFrame
      title="Montoramento"
      imgSrc={"/static/img/no-monitoring.png"}
    >
      <BlockStandard hideDivider>
        <Typography variant="h3" component="p">
          Você ainda não possui sistema solar fotovoltaico nem medidor
          inteligente cadastrado em nosso app.
        </Typography>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Accordion
          defaultExpanded
          sx={{
            border: (theme) => `1px solid ${theme.palette.primary.main}`,
          }}
        >
          <AccordionSummary sx={{ alignItems: "center" }}>
            <Grid item container alignItems="center">
              <img
                alt=""
                src="/static/img/solutions/green-energy.png"
                style={{ width: "55px", marginRight: "8px" }}
              />
              <Typography fontWeight="bold">Solar fotovoltaico</Typography>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ mb: 2 }}>
              Para acessar os dados de monitoramento de seu sistema fotovoltaico
              no app Enermatch é só inserir os dados de acesso à plataforma de
              monitoramento do seu inversor.
            </Typography>
            <ButtonLink
              fullWidth
              variant="contained"
              to="/onboarding/prosumer-monitoring-credentials"
            >
              Inserir dados monitoramento
            </ButtonLink>
          </AccordionDetails>
        </Accordion>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Accordion
          defaultExpanded
          sx={{
            border: (theme) => `1px solid ${theme.palette.primary.main}`,
          }}
        >
          <AccordionSummary sx={{ alignItems: "center" }}>
            <Grid item container alignItems="center">
              <img
                alt=""
                src="/static/img/solutions/consumption.png"
                style={{ width: "55px", marginRight: "8px" }}
              />
              <Typography fontWeight="bold">
                Faça a medição do seu consumo
              </Typography>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Card sx={{ display: "flex", boxShadow: "none" }}>
              <CardMedia
                component="img"
                sx={{
                  flex: 1,
                  objectFit: "scale-down",
                  alignSelf: "center",
                }}
                height="70px"
                image="https://www.enermatch.com/wp-content/uploads/2024/11/foto-principal-smartmeter.jpg"
              />
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="body2">
                  Medidor Inteligente Wi-Fi com TCs
                </Typography>
                <Typography>A partir de:</Typography>
                <Typography variant="body2">R$ 149,00</Typography>
              </CardContent>
            </Card>
            <Typography sx={{ my: 2 }}>
              Para acessar dados de monitoramento do seu consumo de energia é só
              adquirir medidores de energia Enermatch em nossa loja virtual.
            </Typography>
            <ButtonLink fullWidth variant="contained" to="/frames/store">
              Comprar medidores inteligentes
            </ButtonLink>
          </AccordionDetails>
        </Accordion>
      </BlockStandard>
    </SolutionsFrame>
  );
};
